import { Component, OnInit } from '@angular/core';
import { TextInputComponent } from '../../form/text-input/text-input.component';
import { UtilityService } from '../../../../services/utility.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { regex } from '../../../../constants/regex';
import { pageSeoInfo } from '../../../../constants/page-seo-info';
import { SeoService } from '../../../../services/seo.service';
import { Router } from '@angular/router';
import { routes } from '../../../../constants/routes';
import { ApiService } from '../../../../services/api.service';
import { ToasterService } from '../../../../services/toaster.service';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [TextInputComponent],
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.scss',
})
export class VerifyEmailComponent implements OnInit {
  public verifyEmailForm!: FormGroup;

  constructor(
    public utilityService: UtilityService,
    private toaster: ToasterService,
    private seoService: SeoService,
    private apiService: ApiService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.initializeForm();
    const { title, description, canonicalUrl } =
      pageSeoInfo['verifyOrganizationEmail'];
    this.seoService.setPageTitle(title);
    this.seoService.setPageDescription(description);
    this.seoService.setCanonicalUrl(canonicalUrl);
  }

  initializeForm() {
    this.verifyEmailForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(regex.email),
      ]),
    });
  }

  sendOtp() {
    if (this.verifyEmailForm.valid) {
      const email = this.verifyEmailForm.get('email')?.value;
      this.apiService
        .sendOtpToEmail(email)
        .pipe()
        .subscribe({
          next: (res) => {
            this.toaster.success(res.message);
            this.router.navigate(
              ['/', routes.account, routes.user, routes.verifyOtp],
              {
                state: { email },
              },
            );
          },
          error: (error) => {
            this.toaster.error(error.message);
          },
        });
    } else {
    }
  }
}
